<div *ngIf="!hideReset" class="select-group">
  <ion-label (click)="selectCategory('all')">{{ allLabel }}</ion-label>
</div>
<ng-container *ngFor="let item of data">
  <div class="select-group">
    <ion-label
      *ngIf="!item.children || (item.children && !item.children[0])"
      (click)="selectCategory(item)"
    >
      {{ item.title }}
    </ion-label>
    <ng-container *ngIf="item.children && item.children[0]">
      <ion-label class="has-children" (click)="expandCategory(item)">
        {{ item.title }}
      </ion-label>
      <div class="child" [class.open]="expandedCategory?.slug === item.slug">
        <div
          *ngFor="let child of item.children"
          (click)="selectCategory(child)"
        >
          <ion-text>{{ child.title }}</ion-text>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>
